<template>
  <div class="col-md-12 default">
    <equip-device />
  </div>
</template>

<script>
import equipDevice from "./EquipDevice.vue";

export default {
  name: 'EquipDeviceComponent',
  components: {
   equipDevice
  },
  props: ["type"],
  data() {
    return {
      
    };
  },
  computed: {},
  created() {
  },
  mounted() {
  },

  methods: {
   
  },
};
</script>
